export const BRAND = {
  name: "Orvyn FiveM Scripts",
  product: "Orvyn Fight Studio",
  version: "v4.2.0",
  discord: "https://discord.gg/jYR2mBujZP",
  logo:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_e93cba1a-af43-4d37-8f7b-b22b5d73d4e9/artifacts/v4exlpzv_OrvynFivemLogo.png",
  mark: "/orvyn-mark.png",
  lockup: "/orvyn-lockup.png",
  banner:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_e93cba1a-af43-4d37-8f7b-b22b5d73d4e9/artifacts/w7nc9tlj_Banner.webp",
  promo: "/orvyn-promo.jpg",
};

export const SHOWCASE = {
  channelUrl: "https://www.youtube.com/@ORVYNFivemScripts",
  videos: [
    {
      id: "mhPsT-khCVk",
      title: "Orvyn Advanced Fighting Studio — FiveM Script",
      meta: "Full showcase · 0:37",
    },
  ],
};

export const STATS = [
  { value: "262", label: "Animations", sub: "Across 18 packs and every style" },
  { value: "18", label: "Animation packs", sub: "Taekwondo to gun fu and dual knives" },
  { value: "12", label: "Spectators", sub: "Configurable crowd around your scene" },
  { value: "00", label: "Dependencies", sub: "Standalone — no framework, no database" },
];

export const PRODUCT_COPY = {
  "fight-studio": {
    badge: "Flagship release",
    tagline: "Direct cinematic fight scenes in minutes. No framework needed.",
    blurb:
      "Orvyn Fight Studio turns any spot on your map into a fight set. Place an attacker and a victim, pick moves from a library of 262 animations, line up the contact step by step, and play full choreographed fights with a knockout finish. Built for content creators, RP storytelling, trailers and server showcases.",
    includes: [
      "262 animations across 18 packs",
      "Guided lineup with per-model saved placements",
      "Fine contact matching on the impact frame",
      "Sequence builder with optional final KO",
      "4 ready-made fights, including a 60-second fight",
      "Full character editor and saved roster",
      "Up to 12 reacting spectators",
      "Drop in your own .ycd animations",
      "Standalone, escrow-protected, config left open",
    ],
    pairs:
      "Pairs with Orvyn Karate GI’s — install both and the gis become one-click presets in the character editor.",
  },
  "karate-gi": {
    badge: "Add-on clothing",
    tagline: "Clean add-on karate gis for freemode peds.",
    blurb:
      "Traditional karate uniforms for your dojo, fight club, tournament or martial arts RP. Streamed as their own clothing collection, so they won't shift the numbering of your existing clothing packs.",
    includes: [
      "Female: white, red, blue and black & yellow gi",
      "Male: sleeveless and long sleeve, white and black belt",
      "Jacket and matching trousers in every outfit",
      "Drag and drop — ensure orvyn_karate_gis",
      "Own collection, so no clothing conflicts",
      "README with slot numbers and colour combos",
    ],
    pairs:
      "Pairs with Orvyn Fight Studio — the gis become one-click presets and ready-made gi characters in the studio.",
  },
};

export const FIGHT_STUDIO_MEDIA = [
  { src: "/orvyn-promo.jpg", label: "In-game", fit: "cover", caption: "Advanced fighting system — in-game" },
  { src: "/ui/library.png", label: "Library", fit: "contain", caption: "Animation library — search, pack and type filters, sequence numbers" },
  { src: "/ui/lineup.png", label: "Lineup", fit: "contain", caption: "Guided lineup — place, preview, then apply" },
  { src: "/ui/sequence.png", label: "Sequence", fit: "contain", caption: "Sequence builder with optional finishing knockout" },
  { src: "/ui/fights.png", label: "Fights", fit: "contain", caption: "Four ready-made fights, each ending in a knockout" },
  { src: "/ui/characters.png", label: "Characters", fit: "contain", caption: "Assign saved characters and one-click karate gi presets" },
  { src: "/ui/editor.png", label: "Editor", fit: "contain", caption: "Built-in character editor — clothing, face, hair and makeup" },
  { src: "/ui/spectators.png", label: "Spectators", fit: "contain", caption: "Place up to 12 spectators and set their reactions" },
];

export const GI_POSTERS = [
  {
    id: "pack",
    tab: "Female",
    label: "Karate Gi Pack — female",
    src: "/gi/pack-poster.jpg",
    caption: "Red · Blue · White · Black & yellow",
    alt: "Orvyn Karate Gi Pack — red, blue, white and black & yellow female gis",
  },
  {
    id: "pack-male",
    tab: "Male",
    label: "Karate Gi Pack — male",
    src: "/gi/male-pack-poster.jpg",
    caption: "Sleeveless + long sleeve · white belt + black belt",
    alt: "Orvyn Male Karate Gi Pack — sleeveless and long sleeve gis with white and black belts",
  },
];

export const GI_MEDIA = [
  { id: "white", label: "White gi", src: "/gi/white.jpg", swatch: "#e8e4d8" },
  { id: "blue", label: "Blue gi", src: "/gi/blue.jpg", swatch: "#1f7fd6" },
  { id: "red", label: "Red gi", src: "/gi/red.jpg", swatch: "#c9453c" },
  { id: "black-yellow", label: "Black & yellow gi", src: "/gi/black-yellow.jpg", swatch: "#d6b32a" },
];

export const GI_SETS = {
  female: {
    model: "mp_f_freemode_01",
    items: ["White gi", "Red gi", "Blue gi", "Black & yellow gi"],
  },
  male: {
    model: "mp_m_freemode_01",
    items: [
      "Sleeveless · white belt",
      "Sleeveless · black belt",
      "Long sleeve · white belt",
      "Long sleeve · black belt",
    ],
  },
};

export const MARQUEE = [
  "Orvyn FiveM Scripts",
  "262 Animations",
  "18 Packs",
  "Fight Studio",
  "Karate GI’s",
  "Standalone",
  "Your Own Animations",
  "12 Spectators",
  "Escrow Protected",
  "Discord Support",
];

export const CHAPTERS = [
  {
    n: "01",
    kicker: "Animation library",
    title: "262 animations. 18 packs. Every style.",
    body: "Taekwondo, Jeet Kune Do, Wing Chun, full mount grappling, counters and finishers, hand-to-hand takedowns, sword, gun fu, dual knives and more. Attacker and victim moves are paired, with solo practice moves alongside them. Search the whole library, filter by pack or by move type — kicks, punches, takedowns, grappling, weapons — and keep the ones you use most in favourites.",
    tags: ["18 packs", "Paired + solo", "Type filters", "Favourites"],
  },
  {
    n: "02",
    kicker: "Guided lineup",
    title: "Stage it before you shoot it.",
    body: "Place the attacker, place the victim, watch a preview, adjust, then Apply. Nothing gets committed until you've actually seen it. Lineups are saved per move and per model pair, so the same combination is right the next time you use it — in a one-off shot or inside a full sequence.",
    tags: ["Step-by-step", "Preview then apply", "Saved per model pair"],
  },
  {
    n: "03",
    kicker: "Contact matching",
    title: "Land the hit on the exact frame.",
    body: "Scrub to the impact frame and snap a foot or a fist straight onto the target. This is the difference between an animation that plays near someone and a strike your viewers actually flinch at — and once it's matched, it stays matched.",
    tags: ["Frame scrubbing", "Snap to target", "Fine offsets"],
  },
  {
    n: "04",
    kicker: "Sequence builder",
    title: "Choreograph your own fight.",
    body: "Build a fight in any order from any move in the library. Right-click to insert at any position, undo when you change your mind, and finish on an optional finishing KO. Your combos, your pacing, your signature takedown.",
    tags: ["Insert anywhere", "Undo", "Optional final KO"],
  },
  {
    n: "05",
    kicker: "Ready-made fights",
    title: "Four full fights, ready to roll.",
    body: "Four complete choreographed fights are included, up to a full 60 seconds. Load one, press play, and you have finished footage for a trailer, a tournament or a server showcase without building anything first.",
    tags: ["4 full fights", "60-second fight", "KO finish"],
  },
  {
    n: "06",
    kicker: "Playback",
    title: "Director's controls, not a play button.",
    body: "Play, pause, stop, replay, frame-by-frame scrubbing and adjustable playback speed for slow-motion impact. Set a start countdown and the menu auto-hides, so you are watching — or recording — the moment the action begins.",
    tags: ["Frame scrubbing", "Playback speed", "Countdown", "Auto-hide menu"],
  },
  {
    n: "07",
    kicker: "Character editor",
    title: "A full ped editor, built in.",
    body: "Model, face, parents and skin, hair and colours, facial hair, makeup, clothing and accessories. Save characters to a roster and assign them to either actor in one click. Freemode and other ped models are supported, including custom add-on peds, and add-on clothing is saved by collection — so installing other clothing packs won't break saved looks.",
    tags: ["Full face & hair", "Saved roster", "Custom add-on peds", "Collection-safe"],
  },
  {
    n: "08",
    kicker: "Spectators",
    title: "Fill the scene, not just the fight.",
    body: "Place up to 12 spectators (configurable) around your set and set them watching, clapping, cheering or jumping. Move, change or remove any of them individually. An empty alley reads as a test server; a ring of onlookers reads as an underground tournament.",
    tags: ["Up to 12", "Watch / clap / cheer / jump", "Individual control"],
  },
  {
    n: "09",
    kicker: "Your own animations",
    title: "Bring your own moves.",
    body: "Drop .ycd files into a folder and list them in one easy config file. Add your own packs, paired moves, solo moves and complete fights. The /fightstudio_check command tests every custom animation and tells you exactly what's wrong, and a full step-by-step guide is included.",
    tags: [".ycd drop-in", "One config file", "/fightstudio_check", "Guide included"],
  },
  {
    n: "10",
    kicker: "Technical",
    title: "Standalone, and open where it counts.",
    body: "No QBCore, Qbox, ESX, ox_lib or database required. Escrow-protected, with the config, content and custom animation files left open so you can actually tune it. Everything a player configures — looks, characters, placements, sequences — saves on their own computer. Opens with F7 or /fightstudio, and the key can be rebound. Detailed README, user guide and animation guide included.",
    tags: ["No framework", "No database", "Config left open", "F7 / /fightstudio"],
  },
  {
    n: "11",
    kicker: "Good to know",
    title: "Straight answers, up front.",
    body: "Actors and spectators are local to the player using the studio — it's a staging and filming tool, and other players don't see the scene. The studio never changes or takes control of your own character. There's no recording or video export built in, so use your usual capture software.",
    tags: ["Local to you", "Never touches your ped", "Use your own capture"],
  },
];

export const CHANGELOG = [
  {
    version: "Karate GI's v1.0.0",
    date: "Latest",
    current: true,
    summary:
      "Orvyn Karate Female and Male GI's released — eight traditional karate uniforms for freemode peds, streamed as their own clothing collection.",
    entries: [
      { type: "Added", text: "Female gis: white, red, blue and black & yellow (mp_f_freemode_01)" },
      { type: "Added", text: "Male gis: sleeveless and long sleeve, each with a white or black belt (mp_m_freemode_01)" },
      { type: "Added", text: "Jacket and matching trousers in every outfit" },
      { type: "Added", text: "Own clothing collection, so no conflicts with existing add-on clothing" },
      { type: "Added", text: "README with slot numbers and matching colour combinations" },
      { type: "Added", text: "One-click gi presets inside Fight Studio when both resources are installed" },
    ],
  },
  {
    version: "Fight Studio v4.2.0",
    date: "Current release",
    summary:
      "The full choreography release: a 262-animation library, guided lineup, frame-level contact matching, the sequence builder, the character editor, spectators and support for your own animations.",
    entries: [
      { type: "Added", text: "262 animations across 18 packs, from taekwondo to gun fu and dual knives" },
      { type: "Added", text: "Custom animation support — drop in .ycd files and list them in one config file" },
      { type: "Added", text: "/fightstudio_check command validates every custom animation" },
      { type: "Added", text: "Spectators — place up to 12 with watch, clap, cheer and jump reactions" },
      { type: "Added", text: "Optional finishing KO at the end of a custom sequence" },
      { type: "Improved", text: "Guided lineup now saves placements per move and per model pair" },
      { type: "Improved", text: "Fine contact matching on the impact frame for feet and fists" },
      { type: "Improved", text: "Sequence builder — right-click insert at any position, plus undo" },
      { type: "Improved", text: "Character editor supports custom add-on peds and saves clothing by collection" },
      { type: "Improved", text: "Start countdown with auto-hide menu for clean captures" },
      { type: "Added", text: "Detailed README, user guide and animation guide" },
    ],
  },
];

export const FAQS = [
  {
    q: "What does Orvyn sell?",
    a: "Standalone FiveM scripts and assets, built and supported by us. Orvyn Fight Studio is our flagship release, with Orvyn Karate GI’s available as a matching clothing add-on. More is on the way — releases are announced in the Discord.",
  },
  {
    q: "Do I need a framework like ESX, QBCore or Qbox?",
    a: "No. Fight Studio is fully standalone — no QBCore, Qbox, ESX, ox_lib or database required. The Karate GI’s are drag and drop with no scripts at all.",
  },
  {
    q: "Is it escrowed? Can I still configure it?",
    a: "It's escrow-protected, but the config, content and custom animation files are left open. You can change settings, toggle content and add your own animations without touching anything locked.",
  },
  {
    q: "Can I add my own animations?",
    a: "Yes. Drop .ycd files into a folder and list them in one easy config file — your own packs, paired moves, solo moves and complete fights. The /fightstudio_check command tests every custom animation and tells you exactly what's wrong, and a step-by-step guide is included.",
  },
  {
    q: "Do other players see the fight?",
    a: "No. Actors and spectators are local to the player using the studio, so it's a staging and filming tool rather than a combat system. It also never changes or takes control of your own character.",
  },
  {
    q: "Does it record video for me?",
    a: "No — there's no recording or export built in by design. Set your start countdown, let the menu auto-hide, and capture with whatever software you already use.",
  },
  {
    q: "Will the Karate GI’s break my existing clothing packs?",
    a: "No. They're streamed as their own clothing collection, so they won't shift the numbering of any add-on clothing you already run. They work with any clothing menu that supports add-on collections, and the README lists slot numbers and matching colour combinations.",
  },
  {
    q: "How does delivery work?",
    a: "Checkout runs through Tebex. You'll link your FiveM (Cfx.re) account first — that's how Tebex knows who to deliver to — then pay by card or PayPal. Your download and licence land in your Tebex account, usually within seconds.",
  },
  {
    q: "Where do I get support?",
    a: "The Orvyn Discord. Detailed README, user guide and animation guide ship with Fight Studio, and we answer install and config questions directly.",
  },
];
